/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */
import { axiosCommon } from "../util/axiosSetup";
import { ApiPromise } from "../models/ApiPromise";
import { NewInventoryCategoryRequest } from "../models/inventory/category/NewInventoryCategoryRequest";
import { InventoryCategoryResponse } from "../models/inventory/category/InventoryCategoryResponse";
import Params from "../common/Params";

export default class InventoryCategoryApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static createCategory(
    clinicId: string,
    category: NewInventoryCategoryRequest
  ): ApiPromise<InventoryCategoryResponse> {
    const url = `${this.baseUrl}/clinics/${clinicId}/inventories/categories`;
    return axiosCommon.post(url, category);
  }

  static updateCategory(
    clinicId: string,
    categoryId: string,
    category: NewInventoryCategoryRequest
  ): ApiPromise<InventoryCategoryResponse> {
    const url = `${this.baseUrl}/clinics/${clinicId}/inventories/categories/${categoryId}`;
    return axiosCommon.put(url, category);
  }

  static getCategory(
    clinicId: string,
    categoryId: string
  ): ApiPromise<InventoryCategoryResponse> {
    const url = `${this.baseUrl}/clinics/${clinicId}/inventories/categories/${categoryId}`;
    return axiosCommon.get(url);
  }

  static getAllCategories(
    clinicId: string
  ): ApiPromise<InventoryCategoryResponse[]> {
    const url = `${this.baseUrl}/clinics/${clinicId}/inventories/categories`;
    return axiosCommon.get(url);
  }

  static removeCategory(categoryId: string): ApiPromise<void> {
    const url = `${this.baseUrl}/categories/${categoryId}`;
    return axiosCommon.delete(url);
  }
}
